import React from "react";

import Image from "@dip/helsecore/src/components/shared/Image/Image";
import { Chip } from "@hdir/ui/chip";
import { Heading, type HeadingLevel } from "@dip/helsecore/src/components/shared/Heading/Heading";

import type { Image as ImageType } from "@dip/helsecore/src/types/Image";

type PageHeroProps = {
  title: string,
  image?: ImageType,
  chipText?: string
  headingLevel: HeadingLevel | 'p'
}

export default function PageHero(props: Readonly<PageHeroProps>) {
  const {
    title,
    image,
    chipText,
    headingLevel
  } = props;

  if (!title) return null;

  const renderedTitle = headingLevel === "p"
    ? <p className="text-xl font-semibold">{title}</p>
    : <Heading headingLevel={headingLevel}>{title}</Heading>;

  return (
    //  box-shadow and clipPath makes background take 100% vw regardless of container width. Makes it possibie to use the component within a 1-kol layout with max-width 1150px.
    <div className="bg-surface-neutral-subtle-02 shadow-[0_0_0_100vmax_var(--design-color-surface-neutral-subtle-02)] rounded-[0_0_80px_0]" style={{ clipPath: "inset(0 -100vmax)" }}>
      <div className="flex flex-row justify-between items-stretch gap-xl max-w-design-content mx-auto w-[95vw] pt-xxl">
        <div className="flex flex-col gap-md max-w-text-width pb-xxl">
          {chipText && <Chip size="large">{chipText}</Chip>}
          {renderedTitle}
        </div>
        { image
          && (
            <div className="relative hidden tablet:block flex-none w-44">
              <Image
                fetchPriority="high"
                imageRatioClass=""
                overwriteImageCaption=""
                overwriteSizes="176px"
                responsive={false}
                image={image}
                className="absolute bottom-0 right-0 w-full h-full object-contain object-bottom"
              />
            </div>
          )}
      </div>
    </div>
  );
}
